module.exports = __webpack_public_path__ + "static/img/a005.9ac3313.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a005.jpg
// module id = Hx09
// module chunks = 0